import { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import moment from 'moment';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { ChevronDownIcon, ChevronUpIcon } from 'Asset/icon';
import ClockDatetime from 'Component/clock-datetime';
import { Condition, Iteration } from 'Component/others';
import { TextMedium, TextRegular } from 'UiKit/typography';
import violationCodeToText from 'View/host-presence-content/helpers/violationCodeToText';
import { dropdownAnimation } from 'View/host-presence-content/helpers/dropdownAnimation';
import { hostPresenceOverviewText } from 'Const/host-presence-content/view';

import styles from './styles.module.css';

const AttendanceRecordItem = ({ presenceData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation('host-presence');

  const { clockInTime, clockInViolations, clockInNote, clockOutViolations, clockOutNote } = presenceData ?? {};

  const transformedClockInViolations = clockInViolations?.map((violation) => violationCodeToText(violation, t));
  const transformedClockOutViolations = clockOutViolations?.map((violation) => violationCodeToText(violation, t));

  return (
    <Box>
      <Flex gap="6px" align="flex-start" onClick={() => setIsOpen(!isOpen)}>
        <Flex flex={1} flexDir="column" gap="6px">
          <Flex gap="16px">
            <Box width="45%">
              <ClockDatetime
                label={hostPresenceOverviewText.clockInText}
                time={moment(clockInTime).format('HH:mm')}
                date={moment(clockInTime).format('DD/MM/YY')}
              />
            </Box>
            <Box width="55%">
              <ClockDatetime label={hostPresenceOverviewText.clockOutText} time={'-'} date={'-'} />
            </Box>
          </Flex>
          <Flex gap="16px">
            <Flex width="45%" gap="6px" flexWrap="wrap">
              <Iteration
                items={transformedClockInViolations}
                render={(violation) => <Box className={styles['overview-presence__violation']}>{violation}</Box>}
              />
            </Flex>
            <Flex width="55%" gap="6px" flexWrap="wrap">
              <Iteration
                items={transformedClockOutViolations}
                render={(violation) => <Box className={styles['overview-presence__violation']}>{violation}</Box>}
              />
            </Flex>
          </Flex>
        </Flex>
        <Condition statement={isOpen} fallback={<ChevronDownIcon size={20} />}>
          <ChevronUpIcon size={20} />
        </Condition>
      </Flex>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div {...dropdownAnimation}>
            <Box className={styles['dropdown__section']}>
              <Flex gap="6px">
                <Flex flex={1} gap="16px">
                  <Flex width="45%" flexDir="column">
                    <TextRegular fontSize="var(--font-caption1)">{t('page.notes')}</TextRegular>
                    <TextMedium fontSize="var(--font-body3)">{clockInNote || '-'}</TextMedium>
                  </Flex>
                  <Flex width="calc(55% + 30px)" flexDir="column">
                    <TextRegular fontSize="var(--font-caption1)">{t('page.notes')}</TextRegular>
                    <TextMedium fontSize="var(--font-body3)">{clockOutNote || '-'}</TextMedium>
                  </Flex>
                </Flex>
              </Flex>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

export default AttendanceRecordItem;
